<template>
  <div class="prizes-show" :style="{order:h5ConfigDetails[0]['modalOrder']['PrizesShowOrder'][0]}">a
    <div>
      <vue-seamless-scroll
        v-if="h5ConfigDetails[0]['prizesShowSet']['prizesShowStyle'][0] == 1"
        :data="swiperList"
        :class-option="seamlessScrollOption"
        class="prize-carousel"
      >
        <ul>
          <li
            v-for="(item, index) in swiperList"
            :key="index"
          >
          <img :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${item}`" alt="">
          </li>
        </ul>
      </vue-seamless-scroll>
    </div>
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['prizesShowImg']['prizesShowBg'][0]}`" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import VueSeamlessScroll from 'vue-seamless-scroll'

export default {
  name: 'PrizesShow',
  data () {
    return {
      baseUrl,
    }
  },
  components: {
    VueSeamlessScroll
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath']),
    seamlessScrollOption () {
      return {
        step: 1, // 数值越大速度滚动越快
        limitMoveNum: this.swiperList.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: false, // 是否开启鼠标悬停stop
        direction: 2, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        openTouch: true, // 移动端是否开启touch滑动
        switchDelay: 1000
      }
    },
    swiperList () {
      return this.h5ConfigDetails[0]['prizesShowImg']['prizesShowCarousel']
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped lang="less">
  .prizes-show{
    position: relative;
    font-size: 0;
    &>div{
      position: absolute;
      top: 5.6rem;
      width: 30.8rem;
      overflow-x: hidden;
      left: 0;
      right: 0;
      margin: auto;
    }
    .bg{
      width: 100%;
      height: auto;
    }

    .prize-carousel{
      // position: absolute;
      // top: 5.6rem;
      // width: 31.4rem;
      // left: 0;
      // right: 0;
      // margin: auto;
      // overflow: hidden;
      ul {
        display: flex;
      }
      li {
        width: 9.2rem;
        height: auto;
        margin-right: 1.9rem;
      }
      li>img{
        width: 100%;
      }
    }
  }
</style>